<template lang="pug">
  .sort(:class="{'sort_disabled': isDisabled}")
    .sort__container
      .sort__wrapper.swiper-wrapper
        .sort__item.swiper-slide(
          v-for="(sortOption, i) in options"
        )
          a.sort__link(
            :class="{'active': active === sortOption.id, 'reverse': sortOption.reverse && sortOption.order && active === sortOption.id && sortOption.order !== order }"
            href="#"
            :data-index="i"
            @click.prevent="changeSort(sortOption.id, sortOption.order, sortOption.reverse)"
          )
            span(v-html="sortOption.name")
            span.sort__link-arr(
              v-if="sortOption.reverse && sortOption.order && active === sortOption.id"
              v-html="sortOption.order !== order ? ` ${arrows(sortOption.order === 'asc')[0]}` : ` ${arrows(sortOption.order === 'asc')[1]}`"
            )
</template>

<script>
import Swiper from 'swiper'

export default {
  name: 'Sort',
  props: {
    isDisabled: Boolean,
    active: [Number, String],
    options: Array,
    order: String
  },
  methods: {
    arrows (asc) {
      return asc ? ['&#8595', '&#8593'] : ['&#8593', '&#8595']
    },
    changeSort (id, initialOrder, reverse) {
      let order = initialOrder
      if (this.active === id) {
        if (!reverse) {
          return
        }
        order = this.order === 'asc' ? 'desc' : 'asc'
      }
      order = order || null
      this.$emit('change', { id: id, order: order })
    }
  },
  mounted () {
    let activeIndex = 0
    this.options.some((item, i) => {
      if (item.id === this.active || item.reverse === this.active) {
        activeIndex = i
        return i
      }
    })
    this.slider = new Swiper('.sort__container', {
      initialSlide: activeIndex,
      slidesPerView: 'auto',
      simulateTouch: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      centerInsufficientSlides: true,
      freeMode: true
    })
  }
}
</script>

<style lang="scss" scoped>
  .sort {
    @include text-sm;
    font-weight: $font-weight-semibold;
    padding: 12px 0;
    background-color: map-get($color-neutral-black, 4);
    border-radius: $border-radius;
    position: relative;
    overflow: hidden;

    &__container {
      padding: 0 20px;
      margin: 0 -10px;
    }

    &__wrapper {
      display: flex;
      align-items: center;
    }

    &__item {
      margin: 0 10px;
    }

    &__link {
      text-decoration: none;
      color: inherit;
      white-space: nowrap;

      &.active, &.reverse {
        color: $color-primary;
      }

      .sort_disabled & {
        pointer-events: none;
        color: map_get($color-neutral-black, 25);
      }
    }

    &__link-arr {
      display: none;

      .active &, .reverse & {
        display: inline;
      }

      .sort_disabled & {
        display: none;
      }
    }
  }
</style>
